import {Component, OnInit} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {Session} from '../../interfaces/session-data';
import {filter} from 'rxjs/operators';
import {TransactionService} from '../../services/transaction/transaction.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  // breakpoint var
  observerHeight;
  // spinner
  loading = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 80;
  paymentMethod: string = 'card';
  session: Session;
  // height var that gets mat-card height to set spinners to full height as height dynamically grows with the content, although we would like the minimun height to be at least the mat-cards height
  matCardHeight;
  mobile = false;
  hidePgLogo = false;
  constructor(private breakpointObserver: BreakpointObserver, private router: Router, private route: ActivatedRoute, private transactionService: TransactionService) {
    sessionStorage.setItem('selected-payment', 'card');

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.router.navigate([this.session.virtualRoute])
          .then((data) => {
            this.loading = false;
          });
      }
    });

    this.route.queryParams.subscribe((params: { initialised }) => {
      if (params.initialised) {
        this.router.navigate(['virtual/card/tds'])
          .then((data) => {
            // promise returned from navigation
          });
      }
    });
    // !-- Breakpoints (for help on below breakpointObserver)
    // sm: '640px',
    // md: '768px',
    // lg: '1024px',
    // xl: '1280px',
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.router.navigate([this.session.virtualRoute])
          .then((data) => {
            this.loading = false;
          });
      }
    });
  }

  ngOnInit(): void {
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    if (this.router.routerState.snapshot.url.indexOf(`${this.paymentMethod}/`) === -1) {
      // setTimeout(() => {
        this.loading = false;
        this.router.navigate(['add'], { relativeTo: this.route });
      // }, 1000);
    } else {
      this.loading = false;
    }

    this.matCardHeight = document.getElementById('mat-card').clientHeight - 96 + 'px';

  }

}
